import React, { Suspense, lazy } from 'react';

const ReactQuillLazy = lazy(() => import('react-quill'));

const ReactQuillWrapper = React.forwardRef((props, ref) => {
  return (
    <Suspense fallback={<div className="react-quill-fallback">Loading editor...</div>}>
      <ReactQuillLazy ref={ref} {...props} />
    </Suspense>
  );
});

export default ReactQuillWrapper;
